module.exports = __webpack_public_path__ + "img/car-back.cd450a6f.png";